import React, { Component } from 'react';
import { ListScheduleItems, GetCompetition } from './graphql.js';
import { updateInPath } from '../../../common/utils';
import { getList, getItem } from '../../utils/gqlq.js';
import CompetitionFilter from '../../components/competitionFilter';
import {
  SimpleTimetable,
  RoundRobinTable,
  FolkraceTable
} from '../../../private/common/components/Tournament/Tables';
import { Container, Dimmer, Loader,  Message, Image } from 'semantic-ui-react';
import i18next from 'i18next';
import { map, clone } from 'ramda';
import { timeStringToSeconds, secondsToTimeString } from '../../../private/admin/utils/scheduler/helpers.js';

export default class Teams extends Component {
  constructor() {
    super();

    this.state = {
      loading: false,
      competition: {},
      matches: []
    };
    this.filter = {};
  }

  handleCompetitionSelect = async ({ competitionId : { eq: cId }}, eventId) => {
    this.setState(s => updateInPath(s, 'competitionId', cId));
    this.setState(s => updateInPath(s, 'eventId', eventId));
    this.setState(s => updateInPath(s, 'loading', true));

    const c = await getItem('getCompetition', {
      query: GetCompetition,
      variables: { eventId: eventId, competitionId: cId }
    });

    if (c.tournament) {
      c.tournament.i18n_comments = JSON.parse(c.tournament.i18n_comments);
    }

    this.setState(s => updateInPath(s, 'competition', c || {}));

    const m = await getList('listScheduleItems', {
      query: ListScheduleItems,
      variables: { competitionId: cId }
    });

    this.setState(s => updateInPath(s, 'matches', m || []));
    this.setState(s => updateInPath(s, 'loading', false));
  }

  

  render() {
    const { loading, competition } = this.state;

    let matches = clone(this.state.matches);

    const cId = competition.competitionId,
          cType = competition.competitionType,
          cAttemptsLimit = competition.attemptsLimit;
          //genBtnTitle = 'Generate schedule (' + competition.competitionType + ')';


    // HARDCODED!!
    if (cId && competition.code === 'MBP') {
      matches = [];
    }

    // ADD TIME OFFSET
    if (cId && competition.tournament && competition.tournament.timeOffsetInMinutes) {
      const offsetInSeconds = competition.tournament.timeOffsetInMinutes * 60;

      matches = map(m => {
        let bTime =  timeStringToSeconds(m.beginTime) + offsetInSeconds,
            eTime =  timeStringToSeconds(m.endTime) + offsetInSeconds;
        
        m.beginTime = secondsToTimeString(bTime);
        m.endTime = secondsToTimeString(eTime);

        return m;
      }, matches);
    }
    
    return (
      <Container>
        <CompetitionFilter
          disabled={loading}
          textParam='competitionType'
          onSubmit={this.handleCompetitionSelect}/>

        {cId &&
         <div>
           <Dimmer inverted active={!!loading}>
             <Loader inverted content='Loading schedule'/>
           </Dimmer>
           { competition.tournament &&
             competition.tournament.i18n_comments[i18next.language] &&
             <Message>
               <Message.Header>
                 {competition.tournament.i18n_comments[i18next.language]}
               </Message.Header>
             </Message>}
           {/* {cId && competition.code === 'LSo' && <Image src='./LSo.jpeg'/>} */}
           {!loading &&
            <div>
              { cType === 'FOLKRACE' && <FolkraceTable data={matches}/>}
              { cType === 'RRT_DE' && <RoundRobinTable data={matches}/>}
              { (cType === 'TIME' || cType === 'POINTS' || cType === 'POINTS_SUMMED') &&
                <SimpleTimetable data={matches} columns={cAttemptsLimit} />}
            </div>}
         </div>}
        
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/public/containers/Schedule/index.js